import { TransText } from '@/i18n/trans/text';
import { type OffersWarningDTO } from '@/types/dto/agent';
import { type FC } from 'react';

type JourneyWarningMessageProps = {
  warning: OffersWarningDTO | null;
};

const JourneyWarningMessage: FC<JourneyWarningMessageProps> = ({ warning }) => {
  switch (warning?.code) {
    case 'NO_DEPARTURE':
    case 'NOT_ENOUGH_PLACES':
    case 'NOT_ENOUGH_VOUCHERS':
    case 'OFFER_PAX_TYPES_CANNOT_BE_SOLD_ALONE':
    case 'SOLD_OUT':
      return <TransText i18nKey={warning.code} />;
    default:
      return warning?.detail ?? <TransText i18nKey="notAvailable" />;
  }
};

export default JourneyWarningMessage;
